// removed by extract-text-webpack-plugin
module.exports = {"container":"_1slTeG2qmowyU-I-Ey1KvU","tabsContainer":"_3Ne2LAS54PLqZ2QxxDUpUI","tabs":"_3wgtFn6OhVd4TFH1kkma-l","tabsActiveItem":"_1xpDAY8Urv3WORuIetlN7h","tabsItem":"_20QkUg0KN8jKiMHLENQyje"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Tabs/index.css
// module id = 134
// module chunks = 0